import { render, staticRenderFns } from "./DeactivateUserModal.vue?vue&type=template&id=340edaf5&scoped=true"
import script from "./DeactivateUserModal.vue?vue&type=script&lang=js"
export * from "./DeactivateUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeactivateUserModal.vue?vue&type=style&index=0&id=340edaf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340edaf5",
  null
  
)

export default component.exports